import { DrawerPanel } from '@dmc/ui';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import { AssetDeviceType, useListAssetsQuery } from '@casops/store/apis/registeredAssetsApi';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import AssetTracksForm from './components/form/AssetTracksForm';
import { useListAssetGroupsQuery } from '@casops/store/apis/assetGroupsApi';
import { ModelName } from '@casops/store/api';

// Create a query param list of all device types except PPU.
const DevicesWithTracks: AssetDeviceType[] = Object.values(AssetDeviceType).filter(
  type => type !== AssetDeviceType.PPU,
);

export const AssetTracksPanel = (): ReactElement => {
  const { t } = useTranslation();

  const { data } = useListAssetsQuery(
    { query: { deviceTypes: DevicesWithTracks } },
    {
      refetchOnMountOrArgChange: 60,
    },
  );

  const { items: assets } = data ?? {};

  const { data: assetGroups } = useListAssetGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const isLoaded = [assets, assetGroups].every(Boolean);
  const renderKey = useRenderKey({ assets, assetGroups });

  return (
    <DrawerPanel
      isLoaded={isLoaded}
      header={t('Model.Collection.Title', { modelName: ModelName.AssetTrack })}
    >
      <AssetTracksForm key={renderKey} assets={assets ?? []} />
    </DrawerPanel>
  );
};

export default AssetTracksPanel;
